export default "__VITE_ASSET__Djie2X5B__"